import React from 'react';
import './cell-states.css';

export const formatSignedNumber = (value: number | string | null | undefined): string => {
    if (value === null || value === undefined || value === '') return 'N/A';
    const num = Number(value);
    if (isNaN(num)) return 'N/A';
    const formatted = num.toFixed(2);
    return num >= 0 ? `+${formatted}` : formatted;
};

type CellClass = 'cell-positive' | 'cell-negative' | 'cell-failure' | 'cell-neutral';

export const getCellClass = (value: number | null, isFailure = false): CellClass => {
    if (isFailure) return 'cell-failure';
    if (value === null) return 'cell-neutral';
    return value >= 0 ? 'cell-positive' : 'cell-negative';
};

interface PerformanceCellProps {
    value: number | null;
    status: string;
    msg: string;
}

const PerformanceCell: React.FC<PerformanceCellProps> = ({ value, status, msg }) => {
    const isFailure = status === 'failure';
    const cellClass = getCellClass(value, isFailure);

    return (
        <td className={`performance-cell ${cellClass}`}>
            <div className="cell-content">
                <span className="cell-value">{formatSignedNumber(value)}</span>
                {isFailure && (
                    <span className="cell-tooltip" title={msg}>⚠️</span>
                )}
            </div>
        </td>
    );
};

export default PerformanceCell;
